import type { AIConfig, AIProvider } from "./types";
import { createAnthropicProvider } from "./anthropic";

export type { AIProvider, AIConfig, FeedbackRequest, FeedbackKind } from "./types";
export { AIError } from "./types";

export interface ModelOption {
  id: string;
  label: string;
  hint: string;
}

/** Models offered in Settings. IDs are the Anthropic API model identifiers. */
export const AI_MODELS: ModelOption[] = [
  { id: "claude-sonnet-4-6", label: "Claude Sonnet 4.6", hint: "Balanced — recommended" },
  { id: "claude-opus-4-8", label: "Claude Opus 4.8", hint: "Most capable, slower" },
  { id: "claude-haiku-4-5-20251001", label: "Claude Haiku 4.5", hint: "Fastest & cheapest" },
];

export const DEFAULT_MODEL = AI_MODELS[0].id;

/**
 * Build the configured provider. Only Anthropic exists today; this is the seam
 * where a backend-proxy provider would be selected instead.
 */
export function getProvider(cfg: AIConfig): AIProvider {
  return createAnthropicProvider(cfg);
}
